import { Tag, TagLabel, ThemeTypings } from '@chakra-ui/react';
import { startCase } from 'lodash';

import { AssetClass } from '../_openapi/portfolio-optimizer';

const assetClassColorMap: { [k in AssetClass]: ThemeTypings['colorSchemes'] } = {
    Bond: 'blue',
    Equity: 'orange',
    Options: 'red',
    Futures: 'purple',
    Other: 'grey',
};
export const AssetClassTag = ({
    assetClass,
    size = 'sm',
}: {
    assetClass?: AssetClass;
    size?: ThemeTypings['sizes'];
}) => (
    <Tag size={size} variant="subtle" colorScheme={assetClass ? assetClassColorMap[assetClass] || 'gray' : 'gray'}>
        <TagLabel>{assetClass ? startCase(assetClass) : '—'}</TagLabel>
    </Tag>
);
